import React, { useState, useEffect } from "react";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import RefershIcon from '../../../common/assets/images/reload.png';
import { Table, Spinner } from 'react-bootstrap';
import axios from 'axios'; // Import axios directly
import './ModulePermissions.css'
import { useNavigate } from 'react-router-dom';
import axiosInstance from '../../../axiosinterceptor';
import Select  from 'react-select';



const ModulePermissions = () => {
    const navigate = useNavigate();
        const permissions = JSON.parse(sessionStorage.getItem('permissions'));
        useEffect(() => {
            if (permissions && !permissions.admin) {
                navigate('/no-access');
            }
        }, [permissions, navigate]);

    const [dbModules, setDbModules] = useState([]);
    const [dbRoles, setDbRoles] = useState([]);
    const [selectedModule, setSelectedModule] = useState("");
    const [selectedRole, setSelectedRole] = useState("");
    const [accessType, setAccessType] = useState("");
    const [savedPermissions, setSavedPermissions] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [refresh, setRefresh] = useState(false);

    

    useEffect(() => {
        fetchData();
    }, [refresh]);

    const fetchData = async () => {
        setIsLoading(true);
        try {
            const modulesResponse = await axiosInstance.get("/getAdminModulesACS");
            setDbModules(modulesResponse.data.data);

            const rolesResponse = await axiosInstance.get("/getAdminRolesACS");
            const unwantedRoles = ["admin", "System Administrator", "Super user", "Privileged User", "Super User Readonly"];
            const filteredRoles = rolesResponse.data.data.filter(role =>
                !unwantedRoles.some(unwanted => role.role_name.trim().toLowerCase() === unwanted.toLowerCase())
            );
            setDbRoles(filteredRoles);

            const permissionsResponse = await axiosInstance.get("/adminRoleModulePermissionsACS");
            setSavedPermissions(permissionsResponse.data.data);
        } catch (error) {
            console.error("Error fetching data:", error);
            toast.error("Failed to fetch data. Please try again.");
        } finally {
            setIsLoading(false);
        }
    };

    const handleDropdownChange = (type, value) => {
        if (type === "module") setSelectedModule(value);
        else if (type === "role") setSelectedRole(value);
    };

    const handleAccessTypeChange = (type) => {
        setAccessType(type === accessType ? "" : type);
    };

    const handleSavePermissions = async () => {
        if (!selectedModule || !selectedRole) {
            toast.error("Module and Role cannot be empty.");
            return;
        }
        if (!accessType) {
            toast.error("Please select an access type.");
            return;
        }

        const payload = {
            moduleId: parseInt(selectedModule),
            roleId: parseInt(selectedRole),
            accessType,
            createdBy: sessionStorage.userId,
        };

        try {
            await axiosInstance.post("/postAdminRoleModulePermissions", payload);
            toast.success("Permissions saved successfully!");
            setRefresh(!refresh);
            setSelectedModule("");
            setSelectedRole("");
            setAccessType("");
        } catch (error) {
            console.error("Error saving permissions:", error);
            if (error.response && error.response.data && error.response.data.error) {
                const errorMessage = error.response.data.error;
                if (errorMessage.includes("duplicate key value")) {
                    toast.error("This role and module combination with the selected access type already exists.");
                } else {
                    toast.error("Failed to save permissions. Please try again.");
                }
            } else {
                toast.error("An unexpected error occurred. Please try again.");
            }
        }
    };

    const handleRefresh = () => {
        setRefresh(!refresh);
    };
    useEffect(() => {
      return () => {
        toast.dismiss();
      };
    }, []);

    return (
        <div className="userlist-section">
            <ToastContainer />
            <div className="module-permissions-scope">
                 <p
                    className="userlist-back-btn"
                    onClick={() => navigate("/admin")}
                >
                    « Back
                </p>
            <div className="userlist-header">
                <h4 className="userlist-header-text">Module Permissions :</h4>
                <div className="userlist-filter-section" style={{ display: 'flex', alignItems: 'center' }}>
                    <select className="form-control-rolemodule" value={selectedModule} onChange={(e) => handleDropdownChange("module", e.target.value)} style={{ marginRight: '10px' }}>
                        <option value="">Select Module</option>
                        {dbModules.map(module => (
                            <option key={module.module_id} value={module.module_id}>{module.module_name}</option>
                        ))}
                    </select>

                    <select  className="form-control-rolemodule" value={selectedRole} onChange={(e) => handleDropdownChange("role", e.target.value)} style={{ marginRight: '10px' }}>
                        <option value="">Select Role</option>
                        {dbRoles.filter(role => !savedPermissions.some(perm => perm.role_id === role.role_id)).map(role => (
                            <option key={role.role_id} value={role.role_id}>{role.role_name}</option>
                        ))}
                    </select>

                    <label style={{ marginRight: '10px' }}><input type="checkbox" checked={accessType === "read"} onChange={() => handleAccessTypeChange("read")} /> Read</label>
                    <label style={{ marginRight: '10px' }}><input type="checkbox" checked={accessType === "fullAccess"} onChange={() => handleAccessTypeChange("fullAccess")} /> Full Access</label>

                    <button className="userlist-filter-btn" onClick={handleSavePermissions} style={{ marginRight: '10px' }}>Save Permission</button>

                    <span className="userlist-refresh-btn" onClick={handleRefresh}>
                        <span>
                            <img src={RefershIcon} alt="Refresh" />
                        </span>
                    </span>
                </div>
            </div>
            </div>
            <div className="userlist-table-container">
                <Table responsive="sm" style={{ textAlign: 'center' }} className="userlist-filter-table">
                    <thead className="userlist-thead">
                        <tr className="userlist-tr">
                            <th className="userlist-th">Module Name</th>
                            <th className="userlist-th">Role Name</th>
                            <th className="userlist-th">Read</th>
                            <th className="userlist-th">Full Access</th>
                        </tr>
                    </thead>
                    <tbody>
                        {isLoading ? (
                            <tr><td colSpan="4"><div className="userlist-table-loader"><Spinner /></div></td></tr>
                        ) : savedPermissions.map((perm, index) => (
                            <tr key={index}>
                                <td className="userlist-td">{perm.module_name}</td>
                                <td className="userlist-td">{perm.role_name}</td>
                                <td className="userlist-td">{perm.access_type === "read" ? "Yes" : "No"}</td>
                                <td className="userlist-td">{perm.access_type === "fullAccess" ? "Yes" : "No"}</td>
                            </tr>
                        ))}
                    </tbody>
                </Table>
            </div>
        </div>
    );
};

export default ModulePermissions;